import { IAfterGuiAttachedParams, IHeaderParams } from '@ag-grid-community/all-modules';
import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { Component } from '@angular/core';



@Component({
    templateUrl: './nxi-balances-grid-header.component.html'
})

export class NxiBalancesGridHeaderComponent implements IHeaderAngularComp {
    refresh(params: IHeaderParams): boolean {
        throw new Error('Method not implemented.');
    }
    afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
        throw new Error('Method not implemented.');
    }

    params: IHeaderParams;
    nxiHeaderArray: [3];
    subHeadingDisplay: boolean = false;

    agInit(params: IHeaderParams): void {
        this.params = params;
        this.processHeader(params);
    }

    processHeader(params: any) {
        let displayName = params && !!params.displayName ? params.displayName : '';
        let customHeaders = params && params.customHeaders && !!displayName ? params.customHeaders : null;
        this.nxiHeaderArray = customHeaders && customHeaders[displayName] ?
            customHeaders[displayName] : [{ 'name': displayName, 'footer': '', 'className': '' }];
    }

}
